import classNames from 'classnames'

import type { CSSProperties, PropsWithChildren, ReactElement, ReactNode } from 'react'

import OptionsContainer from './OptionsContainer'

import './styles.scss'

export interface Props {
  checkboxInitialValue?: boolean
  className?: string
  disabled?: boolean
  icon?: ReactElement
  iconPosition?: 'left' | 'right'
  inputId?: string
  isCheckboxDisabled?: boolean
  label?: string
  labelPosition?: 'top' | 'left'
  onCheckboxChanged?: (checkboxValue: boolean) => void
  onIconClick?: VoidFunction
  required?: boolean
  size: Exclude<SIZES, 'large'>
  style?: CSSProperties
  tooltip?: ReactNode
  withCheckbox?: boolean
  wrapperClassName?: string
}

const InputWrapper = ({
  checkboxInitialValue,
  children,
  className,
  disabled,
  icon,
  iconPosition = 'left',
  inputId,
  isCheckboxDisabled,
  label,
  labelPosition = 'top',
  onCheckboxChanged,
  onIconClick,
  required,
  size,
  style,
  tooltip,
  withCheckbox,
  wrapperClassName,
}: PropsWithChildren<Props>): ReactElement => {
  /** Local state */

  const parentClasses = classNames(wrapperClassName, 'input-content-container', size, `${labelPosition}-label`)

  const inputClasses = classNames('input-wrapper', className, size, { disabled })

  const iconClasses = classNames('icon-wrapper', { [iconPosition]: !!iconPosition })

  /** Render */

  return (
    <div className={parentClasses}>
      {label || withCheckbox ? (
        <OptionsContainer
          checkboxInitialValue={checkboxInitialValue}
          id={inputId}
          isCheckboxDisabled={isCheckboxDisabled}
          label={label}
          labelPosition={labelPosition}
          onCheckboxChanged={onCheckboxChanged}
          required={required}
          size={size}
          tooltip={tooltip}
          withCheckbox={withCheckbox}
        />
      ) : null}
      <div className={inputClasses} style={style}>
        {iconPosition === 'left' && icon ? (
          <div className={iconClasses} onClick={onIconClick}>
            {icon}
          </div>
        ) : null}
        {children}
        {iconPosition === 'right' && icon ? (
          <div className={iconClasses} onClick={onIconClick}>
            {icon}
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default InputWrapper
